import React, { useState, useEffect } from 'react';
import SpinWheel from './SpinWheel';
import Dashboard from './Dashboard';

// This is the new App.js to correctly render the components.
const App = () => {
  const [view, setView] = useState('spinwheel'); // Set the default view

  const renderContent = () => {
    switch (view) {
      case 'spinwheel':
        return <SpinWheel />;
      case 'dashboard':
        return <Dashboard />;
      default:
        return <div>Halaman tidak ditemukan.</div>;
    }
  };

  return (
    <div className="h-screen font-sans">
      <header className="flex justify-center p-4 bg-gray-900 text-white shadow-md">
        <button 
          onClick={() => setView('spinwheel')} 
          className={`py-2 px-4 rounded-lg font-bold transition-colors duration-200 ${
            view === 'spinwheel' ? 'bg-blue-600' : 'bg-gray-700 hover:bg-gray-600'
          }`}
        >
          Spin Wheel
        </button>
        <button 
          onClick={() => setView('dashboard')} 
          className={`ml-4 py-2 px-4 rounded-lg font-bold transition-colors duration-200 ${
            view === 'dashboard' ? 'bg-blue-600' : 'bg-gray-700 hover:bg-gray-600'
          }`}
        >
          CMS Dashboard
        </button>
      </header>
      <main className="flex-1">
        {renderContent()}
      </main>
    </div>
  );
};

export default App;
